import { Plus, ReceiptIndianRupee } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, DataTable } from "./AccountPrimitives";
import { inr } from "@/lib/format";

export function InvoicesTab({ columns, invoices }) {
  return <DataTable columns={columns} data={invoices} empty="No invoices yet." />;
}

export function PaymentsTab({ columns, payments, onRecordPayment }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button variant="outline" onClick={onRecordPayment}><Plus size={16} /> Record payment</Button>
      </div>
      <DataTable columns={columns} data={payments} empty="No payments recorded." />
    </div>
  );
}

export function PayablesTab({ columns, payables, onCreatePayable, onSettlePayable }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-end gap-2">
        <Button variant="outline" onClick={onCreatePayable}>
          <Plus size={16} /> Create payable
        </Button>
        <Button variant="outline" onClick={onSettlePayable}>
          <ReceiptIndianRupee size={16} /> Settle payable
        </Button>
      </div>
      <DataTable columns={columns} data={payables} empty="No payables yet." />
    </div>
  );
}

export function GSTSummaryTab({ summary, accentBar }) {
  if (!summary) return null;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[
          ["Taxable sales", summary.taxable_sales, "blue"],
          ["Output GST", summary.total_output_gst, "amber"],
          ["Input GST", summary.total_input_gst, "emerald"],
          ["Net GST payable", summary.net_gst_payable, "rose"],
        ].map(([label, value, tone]) => (
          <Card key={label} className="relative overflow-hidden p-5 pl-6">
            <span className={`absolute inset-y-0 left-0 w-1 ${accentBar[tone]}`} />
            <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
            <p className="mt-1 font-display text-2xl font-semibold tabular-nums text-slate-900">{inr(value)}</p>
          </Card>
        ))}
      </div>
      <Card className="grid grid-cols-1 gap-x-6 gap-y-3 p-5 text-sm text-slate-600 sm:grid-cols-2 lg:grid-cols-3">
        <div>Output CGST: <b className="text-slate-900">{inr(summary.output_cgst)}</b></div>
        <div>Output SGST: <b className="text-slate-900">{inr(summary.output_sgst)}</b></div>
        <div>Output IGST: <b className="text-slate-900">{inr(summary.output_igst)}</b></div>
        <div>Input CGST: <b className="text-slate-900">{inr(summary.input_cgst)}</b></div>
        <div>Input SGST: <b className="text-slate-900">{inr(summary.input_sgst)}</b></div>
        <div>Input IGST: <b className="text-slate-900">{inr(summary.input_igst)}</b></div>
      </Card>
    </div>
  );
}
